<div class="trinka_cloud_wrap">
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <h1>Verificador de plágio</h1>
                        <h2>Evite o plágio e detecte conteúdo gerado por IA</h2>
                        <ul class="highted-points">
                            <li>Verifique o plágio de publicações pagas, usando o mais confiável relatório do iThenticate</li>
                            <li>Detecte a presença de conteúdo gerado por IA em qualquer documento</li>
                            <li>Obtenha um escore gratuito de plágio, com uma visão geral das fontes detectadas</li>
                        </ul>
                        <a href="https://cloud.trinka.ai/signup" id="autoEditGetStart" target="_blank">Comece agora</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="mainSliderSection text-center">
                        <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" poster="../../../../../assets/images/plagiarism-check/plagiarism-check.jpg">
                            <source src="../../../../../assets/images/plagiarism-check/plagiarism-check.mp4#t=0.1" type="video/mp4">
                            Your browser does not support the video element. Kindly update it to latest version.
                        </video>
                        <button class="icon-pause" (click)="playPause()" [ngClass]="video_pause ? 'icon-play' : 'icon-pause'"> </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="section-lg trustedby">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h3>Com a confiança de líderes globais</h3>
            </div>
            <div class="col-12">
                <div id="client-logos_white" class="owl-carousel">
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/mit.svg" class="filter" alt="mit">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/IEEE.svg" class="filter" alt="IEEE">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/stanford.svg"  class="filter" alt="standord">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/wiley.svg" class="filter" alt="wiley">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/harvard-white.svg" alt="harvard">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/caltech.svg" class="filter" alt="caltech">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/mu.svg" class="filter" alt="mu">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/polyglots.png" class="img-fluid" alt="polyglots">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/pfizer.svg" class="filter" alt="pfizer">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/abbott.svg" class="filter" alt="abbott">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/princeton-white.svg" alt="princeton">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="writing_need_sections section-lg">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-tl">
                    <h2>Encontre a verificação de plágio mais adequada para você</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="standout-tbl">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Fontes/Recursos</th>
                                    <th>
                                        Escore gratuito<br/>
                                        <p class="powered-by"><span>Powered by</span> <img src="../../../../../assets/images/plagiarism-check/iThenticate_logo.svg" class="iThenticate-logo" width="90" alt="iThenticate" /></p>
                                    </th>
                                    <th>Verificação-padrão de Plágio<br/>
                                        <p class="powered-by"></p>
                                    </th>
                                    <th>Verificação Avançada de Plágio<br/>
                                        <p class="powered-by"><span>Powered by</span> <img src="../../../../../assets/images/plagiarism-check/iThenticate_logo.svg" class="iThenticate-logo" width="90" alt="iThenticate" /></p>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- <tr>
                                    <td>Detetor de conteúdo gerado por IA <span class="newbadge">novo</span></td>
                                    <td>-</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                </tr> -->
                                <tr>
                                    <td>Mais de 89 milhões de artigos acadêmicos pagos</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Mais de 99 bilhões de páginas da Web, atuais e arquivadas</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Mais de 200 milhões de artigos de acesso aberto</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>102 milhões de páginas percorridas e atualizadas todos os dias</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Relatórios interativos com arquivo em PDF que pode ser baixado</td>
                                    <td>-</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="single-wrapper section-md">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="wrap-content">
                    <h3>Ganhe acesso ilimitado ao Relatório de Semelhança da iThenticate com o <span>Trinka Premium Plus</span></h3>
                    <a [routerLink]="['/pricing']" routerLinkActive="active" class="btn-outline-enago">
                        <span>Saiba mais</span> <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                            <path d="M12.5248 15.6833C12.3664 15.6833 12.2081 15.625 12.0831 15.5C11.8414 15.2583 11.8414 14.8583 12.0831 14.6166L16.6998 9.99998L12.0831 5.38331C11.8414 5.14164 11.8414 4.74164 12.0831 4.49998C12.3248 4.25831 12.7248 4.25831 12.9664 4.49998L18.0248 9.55831C18.2664 9.79998 18.2664 10.2 18.0248 10.4416L12.9664 15.5C12.8414 15.625 12.6831 15.6833 12.5248 15.6833Z" fill="black"/>
                            <path d="M17.4415 10.625H3.4165C3.07484 10.625 2.7915 10.3417 2.7915 10C2.7915 9.65833 3.07484 9.375 3.4165 9.375H17.4415C17.7832 9.375 18.0665 9.65833 18.0665 10C18.0665 10.3417 17.7832 10.625 17.4415 10.625Z" fill="black"/>
                          </svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="plagCheckKeyFeatures section-lg">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-tl">
                    <h2>Principais recursos</h2>
                    <div class="HeadingSubLine"></div>
                </div>
                <div class="tabs-wrap">
                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" data-toggle="pill" href="#freeScore">
                                <span>Escore gratuito</span>
                                <div class="poweredBy">
                                    <img src="../../../../assets/images/plagiarism-check/iThenticate_logo.svg" width="115" class="iThenticate-logo" alt="iThenticate_logo" />
                                </div>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="pill" href="#standardPlagiarism">
                                <span>Verificação-padrão de Plágio</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link " data-toggle="pill" href="#advancedPlagiarism">
                                <span>Verificação Avançada de Plágio</span>
                                <div class="poweredBy">
                                    <img src="../../../../assets/images/plagiarism-check/iThenticate_logo.svg" width="115" class="iThenticate-logo" alt="iThenticate_logo" />
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="tab-content">
                    <div id="freeScore" class="tab-pane active">
                        <div class="pc-para">
                            <span>Compara com fontes da Internet e detecta conteúdo gerado por IA</span>
                        </div>
                        <div class="row match-box">
                            <div class="col-lg-6">
                                <div class="c-card key-features-left">
                                    <div id="accordion_free" class="accordion">
                                        <div class="card" [ngClass]="freeshowTab == 1 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="freeScore(1)" data-toggle="collapse" href="#freecollapseOne">
                                                    <span><img src="../../../../assets/images/plagiarism-check/text-block.svg" alt="icon" /></span>
                                                    As 3 principais fontes de correspondência
                                                </a>
                                            </div>
                                            <div id="freecollapseOne" class="collapse show" data-parent="#accordion_free">
                                                <div class="card-body">
                                                    <p>Lista as principais fontes de correspondência, juntamente com a porcentagem de correspondência.</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="freeshowTab == 2 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="freeScore(2)" data-toggle="collapse" href="#freecollapseTwo">
                                                    <span><img src="../../../../assets/images/plagiarism-check/sources.svg" alt="icon" /></span>
                                                    Mostra o escore geral de semelhança
                                                </a>
                                            </div>
                                            <div id="freecollapseTwo" class="collapse" data-parent="#accordion_free">
                                                <div class="card-body">
                                                    <p>O documento receberá uma pontuação no escore de semelhança de conteúdo, com base nos problemas de plágio detectados.</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="freeshowTab == 3 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="freeScore(3)" data-toggle="collapse" href="#freecollapseThree">
                                                    <span><img src="../../../../assets/images/plagiarism-check/text-block.svg" alt="icon" /></span>
                                                    Escore de correspondência na Internet e publicações pagas 
                                                </a>
                                            </div>
                                            <div id="freecollapseThree" class="collapse" data-parent="#accordion_free">
                                                <div class="card-body">
                                                    <p>O documento mostra os escores individuais para a Internet e publicações pagas.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="c-card key-features-right">
                                    <div class="image" [ngClass]="freeshowTab == 1 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/matching-scroe.svg" alt="matching-score" class="matching sources" />
                                    </div>
                                    <div class="image" [ngClass]="freeshowTab == 2 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/overall-score.svg" alt="overall-score" class="highlight" />
                                    </div>
                                    <div class="image" [ngClass]="freeshowTab == 3 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/overall-paid.svg" alt="overall-paid" class="flags hidden" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="standardPlagiarism" class="tab-pane">
                        <div class="pc-para">
                            <span>Compara com fontes da Internet e detecta conteúdo gerado por IA</span>
                        </div>
                        <div class="row match-box">
                            <div class="col-lg-6">
                                <div class="c-card key-features-left">
                                    <div id="accordion_standard" class="accordion">
                                        <!-- <div class="card" [ngClass]="standardshowTab == 1 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="standardPlagiarism(1)" data-toggle="collapse" href="#standardcollapseOne">
                                                    <span><img src="../../../../assets/images/plagiarism-check/cpu-charge.svg" alt="icon" /></span>
                                                    Detetor de conteúdo gerado por IA
                                                </a>
                                            </div>
                                            <div id="standardcollapseOne" class="collapse show" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>Detecta conteúdo gerado por modelos grandes de linguagem, como o ChatGPT.</p>
                                                </div>
                                            </div>
                                        </div> -->
                                      
                                        <div class="card" [ngClass]="standardshowTab == 2 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="standardPlagiarism(2)" data-toggle="collapse" href="#standardcollapseTwo">
                                                    <span><img src="../../../../assets/images/plagiarism-check/sources.svg" alt="icon" /></span>
                                                    Identifica as principais fontes de correspondência
                                                </a>
                                            </div>
                                            <div id="standardcollapseTwo" class="collapse show" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>Lista as principais fontes de correspondência, juntamente com a porcentagem de correspondência.</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="standardshowTab == 3 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="standardPlagiarism(3)" data-toggle="collapse" href="#standardcollapseThree">
                                                    <span><img src="../../../../assets/images/plagiarism-check/text-block.svg" alt="icon" /></span>
                                                    Realça o texto com correspondência
                                                </a>
                                            </div>
                                            <div id="standardcollapseThree" class="collapse" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>Para cada fonte com correspondência, o relatório realça o texto exato onde ocorreu a correspondência.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="standardshowTab == 4 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="standardPlagiarism(4)" data-toggle="collapse" href="#standardcollapseFour">
                                                    <span><img src="../../../../assets/images/plagiarism-check/flag-2.svg" alt="icon" /></span>
                                                    Assinala conteúdo oculto
                                                </a>
                                            </div>
                                            <div id="standardcollapseFour" class="collapse" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>Detecta e assinala texto oculto e caracteres suspeitos em um documento.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="standardshowTab == 5 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="standardPlagiarism(5)" data-toggle="collapse" href="#standardcollapseFive">
                                                    <span><img src="../../../../assets/images/plagiarism-check/share_1.svg" alt="icon" /></span>
                                                    Exclui seções selecionadas
                                                </a>
                                            </div>
                                            <div id="standardcollapseFive" class="collapse" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>Oferece flexibilidade para excluir determinadas seções de um documento do âmbito da verificação.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="c-card key-features-right">
                                    <div class="image video-feature" [ngClass]="standardshowTab == 1 ? 'show' : ''">
                                        <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" poster="../../../assets/images/videos/posters/plagiarism-check.jpg">
                                            <source src="../../../../assets/images/plagiarism-check/AI-Content-Detector.mp4#t=0.1" type="video/mp4">
                                            Your browser does not support the video element. Kindly update it to latest version.
                                        </video>
                                    </div>
                                    <div class="image" [ngClass]="standardshowTab == 2 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/sources.png" alt="paid publications" class="matching sources" />
                                    </div>
                                    <div class="image" [ngClass]="standardshowTab == 3 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/highlight.png" alt="paid publications" class="highlight" />
                                    </div>
                                    <div class="image" [ngClass]="standardshowTab == 4 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/flags-hidden.png" alt="paid publications" class="flags hidden" />
                                    </div>
                                    <div class="image" [ngClass]="standardshowTab == 5 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/eclude-choosen.png" alt="paid publications" class="exclude choosen" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="advancedPlagiarism" class="tab-pane">
                        <div class="pc-para">
                            <span>Verificações comparando com publicações pagas e fontes da Internet. <br/>
                                Verificador de plágio recomendado para artigos acadêmicos.</span>
                        </div>
                        <div class="row match-box">
                            <div class="col-lg-6">
                                <div class="c-card key-features-left">
                                    <div id="accordion" class="accordion">
                                        <div class="card" [ngClass]="showTab == 1 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="advancePlagiarism(1)" data-toggle="collapse" href="#collapseOne">
                                                    <span><img src="../../../../assets/images/plagiarism-check/sources.svg" alt="icon" /></span>
                                                    Identifica as principais fontes de correspondência
                                                </a>
                                            </div>
                                            <div id="collapseOne" class="collapse show" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>Lista as principais fontes de correspondência, juntamente com a porcentagem de correspondência.</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="showTab == 2 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(2)" data-toggle="collapse" href="#collapseTwo">
                                                    <span><img src="../../../../assets/images/plagiarism-check/text-block.svg" alt="icon" /></span>
                                                    Realça o texto com correspondência
                                                </a>
                                            </div>
                                            <div id="collapseTwo" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>Para cada fonte com correspondência, o relatório realça o texto exato onde ocorreu a correspondência.</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="showTab == 3 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(3)" data-toggle="collapse" href="#collapseThree">
                                                    <span><img src="../../../../assets/images/plagiarism-check/flag-2.svg" alt="icon" /></span>
                                                    Assinala conteúdo oculto
                                                </a>
                                            </div>
                                            <div id="collapseThree" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>Detecta e assinala texto oculto e caracteres suspeitos em um documento.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="showTab == 4 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(4)" data-toggle="collapse" href="#collapseFour">
                                                    <span><img src="../../../../assets/images/plagiarism-check/export.svg" alt="icon" /></span>
                                                    Exclui seções selecionadas
                                                </a>
                                            </div>
                                            <div id="collapseFour" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>Oferece flexibilidade para excluir determinadas seções de um documento do âmbito da verificação.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="showTab == 5 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(5)" data-toggle="collapse" href="#collapseFive">
                                                    <span><img src="../../../../assets/images/plagiarism-check/share_1.svg" alt="icon" /></span>
                                                    Oferece opções de compartilhamento
                                                </a>
                                            </div>
                                            <div id="collapseFive" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>Oferece diversas opções para compartilhar o seu relatório de forma transparente.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 dflex">
                                <div class="c-card key-features-right">
                                    <div class="image" [ngClass]="showTab == 1 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/sources.png" alt="paid publications" class="matching sources" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 2 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/highlight.png" alt="paid publications" class="highlight" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 3 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/flags-hidden.png" alt="paid publications" class="flags hidden" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 4 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/eclude-choosen.png" alt="paid publications" class="exclude choosen" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 5 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/share.png" alt="paid publications" class="share" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-lg standOut">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="section-tl">
                    <h2>O que faz o Verificador de Plágio do Trinka se destacar?</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="standout-tbl">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Trinka & <br/> Enago Reports</th>
                                    <th class="grammarly">Grammarly</th>
                                    <th class="quillbot">Quillbot</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- <tr>
                                    <td>Detetor de conteúdo gerado por IA</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr> -->
                                <tr>
                                    <td>
                                        <p>
                                            Relatório do iThenticate
                                            <span class="custom-tooltip">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M10 1.04164C14.9417 1.04165 18.9584 5.05831 18.9584 9.99998C18.9584 14.9416 14.9417 18.9583 10 18.9583C5.05837 18.9583 1.04171 14.9416 1.04171 9.99998C1.04171 5.05831 5.05838 1.04164 10 1.04164ZM10 17.7083C14.25 17.7083 17.7084 14.25 17.7084 9.99998C17.7084 5.74998 14.25 2.29165 10 2.29164C5.75004 2.29164 2.29171 5.74998 2.29171 9.99998C2.29171 14.25 5.75004 17.7083 10 17.7083Z" fill="#414E62"/>
                                                    <path d="M10 8.54165C10.3417 8.54165 10.625 8.82498 10.625 9.16665L10.625 13.3333C10.625 13.675 10.3417 13.9583 10 13.9583C9.65833 13.9583 9.375 13.675 9.375 13.3333L9.375 9.16665C9.375 8.82498 9.65833 8.54165 10 8.54165Z" fill="#414E62"/>
                                                    <path d="M10 5.83335C10.1084 5.83335 10.2167 5.85835 10.3167 5.90002C10.4167 5.94168 10.5084 6.00002 10.5917 6.07502C10.6667 6.15835 10.725 6.24168 10.7667 6.35002C10.8084 6.45002 10.8334 6.55835 10.8334 6.66668C10.8334 6.77502 10.8084 6.88335 10.7667 6.98335C10.725 7.08335 10.6667 7.17502 10.5917 7.25835C10.5084 7.33335 10.4167 7.39168 10.3167 7.43335C10.1167 7.51668 9.88337 7.51668 9.68337 7.43335C9.58337 7.39168 9.49171 7.33335 9.40837 7.25835C9.33337 7.17502 9.27504 7.08335 9.23337 6.98335C9.19171 6.88335 9.16671 6.77502 9.16671 6.66668C9.16671 6.55835 9.19171 6.45002 9.23337 6.35002C9.27504 6.24168 9.33337 6.15835 9.40837 6.07502C9.49171 6.00002 9.58337 5.94168 9.68337 5.90002C9.78337 5.85835 9.89171 5.83335 10 5.83335Z" fill="#414E62"/>
                                                </svg>
                                                <div class="custom-tooltip-content custom-tooltip-transform">
                                                    Disponível com a Verificação Avançada de Plágio
                                                </div>
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>
                                        <p>
                                            Relatórios padrão de plágio
                                            <span class="custom-tooltip">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M10 1.04164C14.9417 1.04165 18.9584 5.05831 18.9584 9.99998C18.9584 14.9416 14.9417 18.9583 10 18.9583C5.05837 18.9583 1.04171 14.9416 1.04171 9.99998C1.04171 5.05831 5.05838 1.04164 10 1.04164ZM10 17.7083C14.25 17.7083 17.7084 14.25 17.7084 9.99998C17.7084 5.74998 14.25 2.29165 10 2.29164C5.75004 2.29164 2.29171 5.74998 2.29171 9.99998C2.29171 14.25 5.75004 17.7083 10 17.7083Z" fill="#414E62"/>
                                                    <path d="M10 8.54165C10.3417 8.54165 10.625 8.82498 10.625 9.16665L10.625 13.3333C10.625 13.675 10.3417 13.9583 10 13.9583C9.65833 13.9583 9.375 13.675 9.375 13.3333L9.375 9.16665C9.375 8.82498 9.65833 8.54165 10 8.54165Z" fill="#414E62"/>
                                                    <path d="M10 5.83335C10.1084 5.83335 10.2167 5.85835 10.3167 5.90002C10.4167 5.94168 10.5084 6.00002 10.5917 6.07502C10.6667 6.15835 10.725 6.24168 10.7667 6.35002C10.8084 6.45002 10.8334 6.55835 10.8334 6.66668C10.8334 6.77502 10.8084 6.88335 10.7667 6.98335C10.725 7.08335 10.6667 7.17502 10.5917 7.25835C10.5084 7.33335 10.4167 7.39168 10.3167 7.43335C10.1167 7.51668 9.88337 7.51668 9.68337 7.43335C9.58337 7.39168 9.49171 7.33335 9.40837 7.25835C9.33337 7.17502 9.27504 7.08335 9.23337 6.98335C9.19171 6.88335 9.16671 6.77502 9.16671 6.66668C9.16671 6.55835 9.19171 6.45002 9.23337 6.35002C9.27504 6.24168 9.33337 6.15835 9.40837 6.07502C9.49171 6.00002 9.58337 5.94168 9.68337 5.90002C9.78337 5.85835 9.89171 5.83335 10 5.83335Z" fill="#414E62"/>
                                                </svg>
                                                <div class="custom-tooltip-content custom-tooltip-transform">
                                                    Disponível com a Verificação-padrão de Plágio
                                                </div>
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>Acesso ilimitado ao Relatório de Semelhança</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>20 páginas/mês</td>
                                </tr>
                                <tr>
                                    <td>Relatório em PDF que pode ser baixado</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="single-wrapper section-md">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="wrap-content">
                    <h3>Obtenha até <span>2 escores gratuitos</span> do iThenticate por mês com o Trinka</h3>
                    <a href="https://cloud.trinka.ai/signup" class="btn-outline-enago" target="_blank">
                        <span>Comece agora</span> <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                            <path d="M12.5248 15.6833C12.3664 15.6833 12.2081 15.625 12.0831 15.5C11.8414 15.2583 11.8414 14.8583 12.0831 14.6166L16.6998 9.99998L12.0831 5.38331C11.8414 5.14164 11.8414 4.74164 12.0831 4.49998C12.3248 4.25831 12.7248 4.25831 12.9664 4.49998L18.0248 9.55831C18.2664 9.79998 18.2664 10.2 18.0248 10.4416L12.9664 15.5C12.8414 15.625 12.6831 15.6833 12.5248 15.6833Z" fill="black"/>
                            <path d="M17.4415 10.625H3.4165C3.07484 10.625 2.7915 10.3417 2.7915 10C2.7915 9.65833 3.07484 9.375 3.4165 9.375H17.4415C17.7832 9.375 18.0665 9.65833 18.0665 10C18.0665 10.3417 17.7832 10.625 17.4415 10.625Z" fill="black"/>
                          </svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-lg">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-xl-5 col-md-12">
                <div class="section-tl">
                    <h2>Cobre mais de 1700 periódicos científicos pagos</h2>
                    <div class="HeadingSubLine"></div>
                    <p>Utilize os algoritmos mais precisos de detecção de semelhança entre textos para verificar a existência de plágio no seu conteúdo e preservar sua integridade e credibilidade. Compare o seu trabalho com artigos publicados pela Wiley, Springer Nature, Taylor & Francis, Sage e muitas outras editoras de prestígio.</p>
                </div>
            </div>
            <div class="col-lg-6 col-xl-6 offset-xl-1  col-md-12">
                <div class="no-image">
                    <img src="../../../../assets/images/plagiarism-check/plagiarism-check-map.png" alt="plag check map" class="img-fluid" />
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-lg pt-0">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="section-tl">
                    <h2>Obtenha uma avaliação da mais alta qualidade com a Verificação de Plágio do Trinka</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-xl-6 col-md-12">
                <div class="section-tl">
                    <p>Escolher a ferramenta certa pode ser um desafio, pois estão disponíveis vários verificadores de plágio. Para facilitar esse processo para você, comparamos alguns verificadores de plágio amplamente usados e o Trinka é o que oferece os resultados mais confiáveis e precisos.</p>
                    <p>Quando testado com uma tese de amostra altamente plagiada, o Verificador de Plágio do Trinka superou em desempenho a maioria das outras ferramentas.</p>
                    <p>Com base em 6 parâmetros, comparamos 3 das principais ferramentas quanto à precisão, tamanho do banco de dados, acessibilidade, facilidade de uso, custo e segurança. O Trinka oferece uma avaliação e uma expertise de primeira linha enquanto mantém os seus dados seguros.</p>
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 offset-xl-1  col-md-12">
                <div class="no-image">
                    <img src="../../../../assets/images/plagiarism-check/plagiarism-check-graph.jpg" alt="plag check graph" class="img-fluid" />
                </div>
            </div>
        </div>
    </div>
</section>

<section class="suitableForSection section-lg" style="background-color: #F5F7F8;">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-tl">
                    <h2>Por que escolher o Verificador de Plágio do Trinka?</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <img src="../../../assets/images/languageScore_icon.svg" width="40" height="40" alt="ppc"/>
                    </div>
                    <div class="media-body">
                        <h4>Escore gratuito de verificação de plágio todos os meses</h4>
                        <p>Verifique gratuitamente a existência de plágio no seu conteúdo antes de gerar um relatório. O seu documento será verificado quanto à existência de plágio com comparações através de toda a Internet e com publicações de acesso aberto e pagas.</p>
                    </div>
                </div>
            </div>
            <!-- <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <img src="../../../assets/images/plagiarism-check/ai-content-detector.svg" width="40" height="40" alt="ppc"/>
                    </div>
                    <div class="media-body">
                        <h4>Detecção de conteúdo gerado por IA</h4>
                        <p>Proteja a integridade do conteúdo detectando texto gerado por IA enquanto também verifica instantaneamente a existência de plágio originado de qualquer modelo grande de linguagem, como o ChatGPT, Bard ou Bing Chat.</p>
                    </div>
                </div>
            </div> -->
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <img src="../../../assets/images/plagiarism-check/standard-check.svg" width="40" height="40" alt="ppc"/>

                    </div>
                    <div class="media-body">
                        <h4>Verificações-padrão de plágio ilimitadas</h4>
                        <p>Tenha acesso ilimitado a verificações-padrão de plágio (verificações de semelhança) fornecidas pela iThenticate, que comparam o seu conteúdo com fontes da Internet e publicações de acesso aberto.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <img src="../../../assets/images/plagiarism-check/detection-technology.svg" width="40" height="40" alt="ppc"/>

                    </div>
                    <div class="media-body">
                        <h4>Tecnologia superior de detecção</h4>
                        <p>Nossa tecnologia de detecção de plágio é utilizada pelas maiores editoras acadêmicas e exclui de forma inteligente qualquer conteúdo citado, para lhe fornecer resultados confiáveis.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="allAboutTrinkaCredit">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="aboutTrinkaCreditHeading">
                    <h2>A Verificação de Plágio usa créditos</h2>
                    <div class="HeadingSubLine"></div>
                </div>
                <div class="creditSectionFeature">
                    <div class="othersPointsForCredits">
                        <p style="margin-bottom: 0px;">Créditos são como fichas que permitem que você utilize vários recursos do Trinka conforme a necessidade.</p>
                        <p>Usuários Premium têm 10 créditos gratuitos por mês e usuários Básicos têm 4. Para saber mais, <a [routerLink]="['/features/credits']">clique aqui</a>.</p>
                    </div>
                    <div class="featurePointsCredits">
                        <span>
                            <img src="../../../../assets/images/credits_icon.png" alt="credits">
                        </span>
                        <p>Cada Verificação-padrão de Plágio usa 12 créditos e cada Verificação Avançada usa 18 créditos.<br />Utilize os seus créditos mensais gratuitos e compre mais somente quando precisar.</p>
                    </div>
                    <div class="othersPointsForCredits">
                        <p style="margin-bottom: 0px;">Usuários do Trinka Premium têm direito a 2 verificações gratuitas de escore de plágio todos os meses.</p>
                        <p>Além disso, você tem até 40% de desconto nas compras de pacotes de créditos.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="section-lg bg-grey">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="section-tl">
                    <h2>Como começar</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="allPlans-wrapper">
                    <div class="plan-content plan-simple">
                        <div class="plan-header"></div>
                        <ul>
                            <li>Escore gratuito</li>
                            <li>Relatório Padrão</li>
                            <li>Relatório Avançado</li>
                            <li>Saldo de créditos renovado todos os meses</li>
                            <!-- <li>Additional Credit Discounting / Purchase</li> -->
                            <li>Custo da compra de créditos em volume</li>
                        </ul>
                    </div>
                    <div class="plan-content plan-basic">
                        <div class="plan-header">
                            Básico
                        </div>
                        <ul>
                            <li><span><b>1 Escore gratuito </b> por mês</span></li>
                            <li><span>Disponível por  <b>12 créditos </b></span></li>
                            <li><span>Disponível por  <b>18 créditos</b></span></li>
                            <li><span><b>4 créditos </b> por mês</span></li>
                            <!-- <li><span><b>6 USD </b> per Extra Credit Purchase</span></li> -->
                            <li><span>Apenas <b class="d-inline"> 3 USD</b> por crédito<br/> (Pacote de 40)</span></li>
                        </ul>
                    </div>
                    <div class="plan-content plan-premium">
                        <div class="plan-header">
                            Premium
                        </div>
                        <ul>
                            <li><span><b>2 Escore gratuitos</b> por mês</span></li>
                            <li><span>Disponível por  <b>12 créditos </b></span></li>
                            <li><span>Disponível por  <b>18 créditos</b></span></li>
                            <li><span><b>10 créditos</b> por mês</span></li>
                            <!-- <li><span><b>3.6 USD</b> per Extra Credit Purchase</span></li> -->
                            <li><span>Apenas <b class="d-inline">1.8 USD</b> por crédito<br/> (Pacote de 40)</span></li>
                        </ul>
                    </div>
                    <div class="plan-content plan-recommended">
                        <div class="plan-header">
                            Premium Plus
                            <span>Recomendado</span>
                        </div>
                        <ul>
                            <li><span><b>2 Escore gratuitos </b> por mês</span></li>
                            <li><span><b>Acesso ilimitado </b></span></li>
                            <li><span>Disponível por  <b>18 créditos</b></span></li>
                            <li><span><b>10 créditos </b> por mês</span></li>
                            <!-- <li><span><b>3.6 USD </b> per Extra Credit Purchase</span></li> -->
                            <li><span>Apenas <b class="d-inline"> 1.8 USD</b> por crédito<br/> ( Pack of 40 )</span></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-md gc-testimonials-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center testi">
                <div class="GCTestmonials">
                    <h2>Depoimentos</h2>
                    <div class="HeadingSubLine"></div>          
                </div>
            </div>
        </div>
    </div>
    <div class="testimonial text-center">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="testimonial-wrap">
                        <!-- <div class="testimonal-icon">
                            <img src="../../../assets/images/testimonial.png" alt="grammar-checker-testimonial">
                        </div> -->
                        <div class="testimonial-slider">
                            <div id="testi" class="carousel slide" data-ride="carousel">
                                <ol class="carousel-indicators">
                                    <li data-target="#testi" data-slide-to="0" class="active"></li>
                                    <li data-target="#testi" data-slide-to="1"></li>
                                    <li data-target="#testi" data-slide-to="2"></li>
                                    <li data-target="#testi" data-slide-to="3"></li>
                                    <li data-target="#testi" data-slide-to="4"></li>
                                    <li data-target="#testi" data-slide-to="5"></li>
                                    <li data-target="#testi" data-slide-to="6"></li>
                                    <li data-target="#testi" data-slide-to="7"></li>
                                    <li data-target="#testi" data-slide-to="8"></li>
                                    <li data-target="#testi" data-slide-to="9"></li>
                                    <li data-target="#testi" data-slide-to="10"></li>
                                    <li data-target="#testi" data-slide-to="11"></li>
                                    <li data-target="#testi" data-slide-to="12"></li>
                                </ol>
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/James-Smith.jfif" alt="james smith">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Primeiramente, eu amo Trinka. Parabéns por desenvolverem algo que ajuda amplamente
                                                        na edição, especialmente convenções gramaticais críticas e reduções na
                                                        contagem de palavras.
    
                                                    </p>
                                                    <p class="authorNameText">James Smith</p>
                                                    <span class="authorDesignationText">Editor Acadêmico, EUA</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Rosa-Diaz-Sandoval.jfif" alt="Rosa-Diaz-Sandoval">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Escrever textos com gramática e estilo corretos em inglês não é uma tarefa
                                                        fácil para pessoas que falam outros idiomas. Às vezes, você não consegue
                                                        encontrar pequenos erros em seu documento sem ajuda, especialmente para
                                                        redação acadêmica. Experimentei Trinka Al como ferramenta de correção
                                                        automática e fiquei bastante satisfeita com as correções sugeridas e
                                                        o feedback. Com o feedback você entende porque a mudança sugerida deve
                                                        ser levada em consideração.</p>
                                                    <p class="authorNameText">Rosa Diaz Sandoval</p>
                                                    <span class="authorDesignationText">PhD em Física e Matemática, México</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Dr_Farooq_Rathore.jpg" alt="farooq rathore" />
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Uso trinka especialmente para melhorar a linguagem, gramática e sintaxe dos
                                                        manuscritos científicos que escrevo para periódicos biomédicos nacionais
                                                        e internacionais. Achei a interface amigável e o procedimento, em si,
                                                        é eficiente e descomplicado. As diferentes opções para para editar o
                                                        manuscrito conforme às necessidades me ajudam a decidir em qual área
                                                        devo focar. A edição automática é de grande ajuda e a página suplementar
                                                        com o resumo da revisão é uma excelente idéia. </p>
                                                    <p class="authorNameText">Dr. Farooq Rathore</p>
                                                    <span class="authorDesignationText">Professor Assistente e Chefe de Departamento, Paquistão</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Georgieva-Milena.jpg" alt="Georgieva-Milena">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Trinka Al é a minha escolha favorita para edição gramatical e ortográfica.
                                                        A plataforma funciona corretamente, é rápida e organizada! Estou completamente
                                                        satisfeita!
                                                    </p>
                                                    <p class="authorNameText">Milena Georgieva</p>
                                                    <span class="authorDesignationText">Pesquisador</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Dinesh-Gupta.jfif" alt="dinesh gupta">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">A ferramenta de verificação gramatical supera o Grammarly! Verifiquei novamente
                                                        alguns documentos que havia verificado anteriormente com o Grammarly.
                                                        Fiquei agradavelmente surpreso ao me deparar com tal produto originário
                                                        da Índia.
                                                    </p>
                                                    <p class="authorNameText">Dinesh Gupta</p>
                                                    <span class="authorDesignationText">Radiologista, Índia</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Edith-Davies.jpg" alt="Edith-Davies">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Testei Trinka e fiquei impressionada com suas excelentes capacidades. Trinka
                                                        é melhor do que o verificador gramatical que uso. Parabéns! Falei para
                                                        os meus colegas de laboratório de pesquisa para usarem Trinka. Espero
                                                        que Trinka seja usado amplamente no meio acadêmico.
                                                    </p>
                                                    <p class="authorNameText">Edith Davies</p>
                                                    <span class="authorDesignationText">Bolsista de Doutorado, Reino Unido</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Noor-Al-rishi.png" alt="noor-al-rishi">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">As correções e feedback sugeridos por Trinka Al me surpreenderam. É simples
                                                        de usar e extremamente benéfico.
                                                    </p>
                                                    <p class="authorNameText">Noor Al-rishi</p>
                                                    <span class="authorDesignationText">Bolsista de Química, Arábia Saudita</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Nwaji-Jude.jpg" alt="Nwaji-Jude">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Tem sido uma experiência maravilhosa usar Trinka e quase não consigo enviar
                                                        nenhum manuscrito sem que seja verificado por ele. Em resumo, Trinka
                                                        tem sido um salva-vidas.
                                                    </p>
                                                    <p class="authorNameText">Nwaji Jude</p>
                                                    <span class="authorDesignationText">Pesquisador</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Stumpf-Curtis.jfif" alt="stumpf curtis">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Gosto de usar Trinka como verificação final para meus documentos editados.
                                                        Trinka realmente ajuda a encontrar erros remanescentes que escapam durante
                                                        a primeira verificação. Gosto muito desta plataforma. O botão do polegar
                                                        para baixo é muito útil.
    
                                                    </p>
                                                    <p class="authorNameText">Stumpf Curtis</p>
                                                    <span class="authorDesignationText">Pesquisador</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Dyke-Gareth.jfif" alt="dyke gareth">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Acho Trinka Al uma ideia muito interessante e potencialmente útil, especialmente
                                                        para editores/periódicos. Eu achei trinka muito útil quando verifiquei
                                                        o meu trabalho de edição na plataforma.
                                                    </p>
                                                    <p class="authorNameText">Gareth Dyke</p>
                                                    <span class="authorDesignationText">Pesquisador</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Bhargava-Sharma.jfif" alt="bhargava sharma">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Estou feliz com o desempenho geral. Uso Grammarly faz muito tempo, mas quando
                                                        se trata de redação acadêmica ou técnica, Trinka é definitivamente uma
                                                        opção melhor. As configurações de documentos acadêmicos e a edição automática
                                                        de arquivos são os meus recursos favoritos.
                                                    </p>
                                                    <p class="authorNameText">Bhargava Sharma</p>
                                                    <span class="authorDesignationText">Epidemiologista, Índia</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Ralph-Bailey.jfif" alt="ralph bailey">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Trinka tornou-se minha ferramenta favorita para correções gramaticais. As
                                                        correções com inteligência artificial e os aprimoramentos de linguagem
                                                        tornaram a escrita muito mais fácil. Agora, posso me concentrar mais
                                                        na pesquisa do que em escrever um documento livre de erros.
                                                    </p>
                                                    <p class="authorNameText">Ralph Bailey</p>
                                                    <span class="authorDesignationText">Neurologista, EUA</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Thomas-Andres.jfif" alt="thomas andres">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">A correção gramatical e a sugestão com base no guia de estilo da AMA são
                                                        realmente impressionantes! Trinka é, de fato, a melhor ferramenta de
                                                        correção gramatical para redação médica.
    
                                                    </p>
                                                    <p class="authorNameText">Thomas Andres</p>
                                                    <span class="authorDesignationText">Cardiologista, Brasil</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                </div>
                            </div>
                            <!-- <a class="carousel-control-prev" href="#testi" data-slide="prev">
                                <span class="carousel-control-prev-icon"></span>
                            </a>
                            <a class="carousel-control-next" href="#testi" data-slide="next">
                                <span class="carousel-control-next-icon"></span>
                            </a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="use_trinka_other_app accomplishBrilliantWrap">
    <div class="container">
        <div class="accomplishBrilliantSection">
            <h2>Evite o plágio e submeta o seu trabalho com confiança  </h2>
            <a href="https://cloud.trinka.ai/signup" target="_blank">Comece agora</a>
        </div>
    </div>
</div>

<div class="pricingQuestionAnwser" #target>
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="pricingHeadingQuestion">
                    <h2>Perguntas Frequentes</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <div class="pricingQuestionsList">
                    <div class="accordion" id="faq">
                        <div class="card">
                            <div class="card-header" id="QuestionOne">
                                <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                    Como funciona a Verificação de Plágio Trinka?</a>
                            </div>

                            <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                <div class="card-body">
                                    <h4>É fácil!</h4>
                                    <ol>
                                        <li>Entre na sua Conta Trinka na Nuvem. (Ainda não se inscreveu em uma conta gratuita?  <a href="https://cloud.trinka.ai/signup" target="_blank">Inscreva-se agora!</a> )</li>
                                        <li>Navegue até a <strong>página de Verificação de Plágio clicando nela no painel do lado direito.</strong></li>
                                        <li>Envie um documento e selecione a verificação que for melhor para você. Você também pode selecionar um arquivo que você já enviou para o Trinka.</li>
                                        <li>Obtenha o relatório detalhado em minutos!</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="QuestionTwo">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                    aria-controls="QuestionTwoContent">
                                    Qual é a diferença entre a Verificação de Plágio Trinka e as outras? </a>
                            </div>

                            <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                <div class="card-body">
                                    <p>Ao contrário de outras ferramentas, o Trinka permite que você escolha uma verificação de plágio que atenda às suas necessidades – com conteúdo da Internet ou com Internet + publicações pagas. Nossa tecnologia, em parceria com a iThenticate, oferece detecção superior que tem a confiança de grandes editoras acadêmicas em todo o mundo.</p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="QuestionThree">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                    aria-controls="QuestionThreeContent">
                                    Posso usar a Verificação de Plágio Trinka de graça?
                                </a>
                            </div>

                            <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                <div class="card-body">
                                    <!-- <p>Yes. All Basic users get 1 free Plagiarism Score every month. All Premium users get 2 free Plagiarism Score checks every month. You can run as many checks as you like with <a [routerLink]="['/features/credits']">credits</a>.</p> -->
                                    <p>Você tem verificações de plágio gratuitas no Trinka!</p>
                                    <p>Se você tiver uma conta Básica, terá 1 verificação de escore de plágio gratuita por mês. Se tiver uma conta Trinka Premium, terá 2 verificações de escore de plágio gratuitas por mês.</p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="QuestionFour">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                    aria-controls="QuestionFourContent">
                                    Posso baixar o relatório da Verificação de Plágio?
                                </a>
                            </div>

                            <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                <div class="card-body">
                                    <p>Sim! Os relatórios são em PDF e podem ser baixados a qualquer momento depois de gerados.</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-lg-1"></div>
        </div>
    </div>
</div>
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/Mc_EZXIzvFU"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>

<!-- The Modal -->
<div class="modal" id="freePlagiarismScore">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header bb-none">
          <h4 class="modal-title">
            Pontuação da amostra</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
  
        <!-- Modal body -->
        <div class="modal-body">
          <img src="../../../../assets/images/reports/report_list_item.png" class="img-fluid" />
        </div>
      </div>
    </div>
</div>